import React, { useState, useEffect } from "react";

import { useStore } from "../../../Store";
import Helpers from "../../Functions/Helpers";
import { PageLayoutWithGetData } from "../../Controls/PageLayout";
import { useNavigate } from "react-router-dom";
import { AxiosRequestConfig } from "axios";
import {
  Box,
  Button,
  Center,
  FormControl,
  FormLabel,
  Heading,
  Image,
  Input,
  Text,
} from "@chakra-ui/react";

export default function SelectCustomer() {
  const navigate = useNavigate();

  const {
    data,
    selectedDataHolder,
    token,
    setLoading,
    selectedDataHolderBrand,
    setSelectedCustomer,
    setSelectedDataHolderBrand,
    setShowPopup,
    setShowPopupError,
    setPopupErrorMessage,
    showPopupError,
  } = useStore();

  const [customerId, setCustomerId] = useState("");
  const [disableContinueButton, setDisableContinueButton] = useState(true);

  const [showUserNotFoundError, setShowUserNotFoundError] = useState(false);

  const endpoint = process.env.REACT_APP_MOCK_API_BASE_URI;
  const headers = {
    Authorization: "Bearer " + token?.access_token,
  };

  useEffect(() => {
    setLoading(true);

    const config: AxiosRequestConfig = {
      method: "get",
      url:
        endpoint + "/dataholderbrands/" + selectedDataHolder?.dataHolderBrandId,
      headers: headers,
    };

    Helpers.CallApi(
      config,
      (response) => {
        // Handle success
        setSelectedDataHolderBrand(response.data);
        setLoading(false);
      },
      (message) => {
        //handle error
        HandleError(message);
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (customerId === "") {
      setDisableContinueButton(true);
    } else {
      setDisableContinueButton(false);
    }
  }, [customerId]);

  function OnclickContinue() {
    setLoading(true);

    const config: AxiosRequestConfig = {
      method: "get",
      url:
        endpoint +
        "/dataholderbrands/" +
        selectedDataHolder?.dataHolderBrandId +
        "/customers/" +
        customerId,
      headers: headers,
    };

    Helpers.CallApi(
      config,
      (response) => {
        // Handle success
        setSelectedCustomer(response.data);
        navigate("/OneTimePassword");
      },
      (message) => {
        //handle error
        HandleError(message);
      }
    );
  }

  function HandleError(message: string) {
    setLoading(false);
    setShowPopup(false);

    if (message === "Request failed with status code 404") {
      setShowUserNotFoundError(true);
      return;
    }

    setShowPopupError(true);
    setPopupErrorMessage(message);
  }

  return (
    <PageLayoutWithGetData
      backgroundColor={selectedDataHolderBrand?.backgroundColor}
      isMockBankScreen={true}
      hasContainerPadding={false}
    >
      {!showPopupError && (
        <Box px={10} py={5}>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              e.stopPropagation();
              if (!disableContinueButton) {
                OnclickContinue();
              }
            }}
          >
            <Center mt={4} mb={4}>
              <Image
                shadow="lg"
                maxH="300px"
                maxW="300px"
                borderRadius="xl"
                src={selectedDataHolderBrand?.logoUri}
                alt={selectedDataHolderBrand?.brandName + " Logo"}
              />
            </Center>

            <Heading variant="pageHeading">
              Connect to {selectedDataHolderBrand?.brandName}
            </Heading>

            <Text>
              Please provide your Customer ID to connect{" "}
              {
                data?.softwareProduct?.dataRecipientBrand?.dataRecipient
                  ?.legalEntityName
              }{" "}
              to {selectedDataHolderBrand?.brandName}
            </Text>

            <FormControl mt={3} mb={5}>
              <FormLabel fontWeight="bold">Customer ID</FormLabel>
              <Input
                autoFocus
                bg="white"
                id="txtCustomerId"
                type="text"
                placeholder="Enter your Customer ID"
                aria-label="Enter your Customer ID."
                onChange={(val) => setCustomerId(val.target.value)}
              />
              {showUserNotFoundError && (
                <Text color={"red"}>
                  Sorry, we can't find a record with the Customer ID entered.
                  You can try using 'CRN1' or 'CRN2' as Customer IDs.
                </Text>
              )}
            </FormControl>

            <Text>
              Go to the {selectedDataHolderBrand?.brandName} website to find out
              more about your Customer ID and how to retrieve it.
            </Text>
            <Center>
              <Button
                mt={4}
                mb={6}
                disabled={disableContinueButton}
                variant="primary"
                w="190px"
                h="48px"
                id="btnContinue"
                data-testid="btnContinue"
                aria-label="Continue Button"
                onClick={OnclickContinue}
              >
                Continue
              </Button>
            </Center>
          </form>
        </Box>
      )}
    </PageLayoutWithGetData>
  );
}
